<template>
  <div>
     <div class="searchBox" :style="{ opacity: config.isConfigMode ? 0.5 : 1, pointerEvents: config.isConfigMode ? 'none' : 'auto' }">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
        <el-form-item label="客户名称" v-if="newAuth('bill:week:findAll')">
          <el-input v-model="dataForm.customerName" clearable></el-input>
        </el-form-item>
         <el-form-item label="账单名称">
          <el-input v-model="dataForm.name" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()" type="primary">查询</el-button>
          <el-button v-if="newAuth('bill:week:send')" @click="sendEmailV2('batch')" type="primary" :disabled="!selectFeeData.length">发送邮件</el-button>
          <el-button v-if="newAuth('bill:week:delete')" type="danger" size="small" @click="deleteHandle()">删除</el-button>
          <el-button size="small" @click="templateConfigurationMode(0)" type="warning">模板配置模式</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tableBox" :style="{ position: 'relative' }">
      <!-- 配置模式 -->
      <el-row v-if="config.isConfigMode" style="justify-self: center;padding: 10px 10px">
        <el-button size="mini" @click="config.isConfigMode = false" type="danger">取消配置模式</el-button>
        <el-button v-no-more-click size="mini" @click="templateConfigurationMode(1)" type="success">保存模板</el-button>
        <el-button v-no-more-click size="mini" @click="templateConfigurationMode(2)" type="warning">修改模板</el-button>
        <el-button v-no-more-click size="mini" @click="$refs.configTableRef.init(config.configTableId)" type="warning">所有模板</el-button>
        <el-popover placement="right" width="520" trigger="click">
          <div style="justify-self: center;">
            <el-button v-no-more-click @click="checkAllNodes(true)" size="mini">全选</el-button>
            <el-button v-no-more-click @click="checkAllNodes(false)" size="mini">全不选</el-button>
            <el-tooltip class="item" effect="dark" content="可拖拽必须先取消固定才允许拖拽排列,如果有固定固定按钮会显示为绿色" placement="top-start">
              <i class="el-icon-view el-icon--right" />
            </el-tooltip>
          </div>
          <br/>
          <el-tree :data="config.configDefaultColumn"
                   style="max-height: 200px;overflow-y: auto;"
                   default-expand-all
                   show-checkbox
                   draggable
                   node-key="prop"
                   ref="configTableListTree"
                   @check-change="handleCheckChange"
                   @node-drop="handleDrop"
                   :allow-drag="allowDrag"
                   :allow-drop="allowDrop">
                  <span class="custom-tree-node" slot-scope="{ node, data }">
                    <el-row :gutter="20">
                       <el-col :span="16">
                         <div class="grid-content bg-purple">
                           <el-input size="mini" placeholder="列头名" v-model="data.label"></el-input>
                         </div>
                       </el-col>
                       <el-col :span="8">
                         <div class="grid-content bg-purple">
                           <el-link :type="data.fixed && data.fixed === 'left' ? 'success' : 'info'" @click="data.fixed = 'left'" :underline="false" >固定左侧</el-link>
                           <el-link :type="data.fixed && data.fixed === 'right' ? 'success' : 'info'" @click="data.fixed = 'right'" :underline="false" >固定右侧</el-link>
                           <el-link :disabled="!data.fixed" :underline="false" @click="data.fixed = undefined" >取消固定</el-link>
                         </div>
                       </el-col>
                    </el-row>
                  </span>
          </el-tree>
          <el-button style="margin-left: 10px;" size="mini" slot="reference" icon="el-icon-s-tools" circle />
        </el-popover>
        <br/>
        <br/>
        <el-row type="flex" class="row-bg" justify="space-around">
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <el-input v-model="config.configModeForm.name" size="mini" placeholder="模板名称" clearable />
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple-light">
              <el-input v-model="config.configModeForm.remark" size="mini" placeholder="备注" clearable />
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <el-switch
                  v-model="config.configModeForm.defaultOrNot"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :active-value="'1'"
                  :inactive-value="'0'">
              </el-switch>
            </div>
          </el-col>
        </el-row>
      </el-row>

      <el-table :data="dataList" border size="small" height="72vh" ref="tableRef"
                @row-click="rowClick"
                :row-style="selectedHighlight"
                v-loading="dataListLoading" style="width: 100%;"
                @selection-change="handleSelectionChange"
                :cell-class-name="getCellClassName">
        <el-table-column type="selection" width="40" fixed="left"></el-table-column>
        <el-table-column
            v-for="(item, index) in config.configDefaultColumn"
            :key="index"
            align="left"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :fixed="item.fixed"
            :show-overflow-tooltip="true"
            v-if="item.check"
            :class="item.styleClass"
            :class-name="item.styleClass">
          <template slot-scope="scope">
            <!-- 账单名称 -->
            <template v-if="item.prop == 'name'">
              <span @click="viewBill(scope.row)" style="cursor:pointer; color: blue">{{scope.row.name}}</span>
            </template>
            <!-- 发送状态 -->
            <template v-else-if="item.prop == 'sendStatus'">
              <el-tag v-if="scope.row.sendStatus == 2" size="small" type="warning">已发送</el-tag>
              <el-tag v-else size="small" type="danger">未发送</el-tag>
            </template>
            <template v-else>
              {{ getFormatter(item.formatter)(scope.row, item, _.get(scope.row, item.prop)) }}
            </template>
          </template>
        </el-table-column>
        <el-table-column fixed="right" header-align="center" width="40" label="操作">
          <template slot-scope="scope">
            <el-popover placement="bottom" popper-class="popoerOpt" class="popoerBox" trigger="click">
              <el-button v-if="newAuth('bill:week:send')" type="text" @click="sendEmailV2('single', scope.row)" size="small">发送邮件</el-button>
              <el-button v-if="newAuth('bill:week:download')" type="text" size="small" @click="downLoadV2(scope.row.id)">下载Excel</el-button>
              <el-button v-if="newAuth('bill:week:delete')" type="text" size="small" @click="deleteHandle(scope.row)">删除</el-button>
              <el-button slot="reference" class="referenceBtn">
                <icon-svg name="caozuo" class="site-sidebar__menu-icon"></icon-svg>
              </el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
        :current-page="pageIndex"
        :page-sizes="[20, 50, 100]"
        :page-size="pageSize"
        :total="totalPage"
        layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>

    <view-bill-detail ref="viewBill"></view-bill-detail>

    <!-- 模板配置弹窗 -->
    <configTable ref="configTableRef" />

    <el-dialog title="选择应收费用池模板发送" :visible.sync="tabulation.show" width="30%">
      <el-form :inline="true" :model="tabulation" size="small">
        <el-form-item label="选择模板">
          <el-select class="item-choose" v-model="tabulation.configId" size="small" filterable clearable placeholder="请选择">
            <el-option v-for="(item,index) in tabulation.tabulationList" :key="index" :label="item.name" :value="item.id" ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tabulation.show = false">取 消</el-button>
        <el-button type="primary" @click="submitCommonSubmitReceivableCustomer">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import configTable from "@/components/table"
import viewBillDetail from './detail/viewBillDetail'
import qs from 'qs'
import * as myJsonClon from "@/utils/myJsonClone";
export default {
  components:{
    configTable,
    viewBillDetail
  },
  data () {
    return {
      // -----------------动态表格模式start-----------------
      config: {
        configId: null,
        configTableId: 27,
        configDefaultColumn: [
          {label: '客户名称',prop: 'customerName',fixed: undefined,width: '100',check: true},
          {label: '账单名称',prop: 'name',fixed: undefined,width: undefined,check: true},
          {label: '账单编号',prop: 'billNo',fixed: undefined,width: '120',check: true},
          {label: '账单订单数',prop: 'orderNum',fixed: undefined,width: '80',check: true},
          {label: '账单总金额',prop: 'totalMoney',fixed: undefined,width: '80',check: true},
          {label: '发送状态',prop: 'sendStatus',fixed: undefined,width: '60',check: true},
          {label: '发送时间',prop: 'sendTime',fixed: undefined,width: '130',check: true},
          {label: '账单生成日期',prop: 'createTime',fixed: undefined,width: '130',check: true},
          {label: '账单开始日期',prop: 'beginTime',fixed: undefined,width: '90',check: true},
          {label: '账单结束日期',prop: 'endTime',fixed: undefined,width: '90',check: true},
        ],
        configDefaultPropColumn: [],
        isConfigMode: false,
        configModeForm: {
          name: '',
          remark: '',
          defaultOrNot: '0'
        },
        configDefaultPropColumnMap: new Map(),
      },
      // -----------------动态表格模式end-----------------

      dataForm: {
        name: null,
        customerName: null,
        type: 1,
        billType: 2,
        customerIdList: []
      },
      dataList: [],
      pageIndex: 1,
      getIndex: -1,
      pageSize: 20,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      selectFeeData: [],


      tabulation: {
        configId: null,
        ids: null,
        type: null,
        show: false,
        tabulationList: [],
        requestV: {},

      },

      // 租户信息
      tenantInfo: null
    }
  },
  activated () {
    this.initConfigTable()

    this.getDataList()
  },
  created() {
    // 获取当前租户信息
    this.$http({
      url: this.$http.adornUrl(`/tenant/${sessionStorage.getItem('Tenant-Id')}`),
      method: 'get'
    }).then(({ data }) => {
      if (data) {
        this.tenantInfo = data
      }
    })
  },
  computed: {
    currentUser: {
      get () {
        return this.$store.state.user.currentUser
      }
    },
    dictTypeMap: {
      get () {
        return this.$store.state.common.dictTypeMap
      }
    }
  },
  methods: {
    // -----------------动态表格模式start-----------------
    initConfigTable() {
      this.$http({
        url: this.$http.adornUrl('/tabulation/default/' + this.config.configTableId),
        method: 'get',
        params: this.$http.adornParams()
      }).then(async ({ data }) => {
        if (data) {
          this.config.configModeForm.name = data.name
          this.config.configModeForm.remark = data.remark
          this.config.configModeForm.defaultOrNot = data.defaultOrNot
          this.config.configId = data.id
          if (data.tmsTabulationConfigValueList && data.tmsTabulationConfigValueList.length > 0) {
            this.assignPropertiesLarge(this.config.configDefaultColumn, data.tmsTabulationConfigValueList,'prop',['label','fixed','width'])
            this.config.configDefaultColumn = this.reorderArray(this.config.configDefaultColumn, data.tmsTabulationConfigValueList, 'prop');
          }
        }
        this.config.configDefaultColumn.forEach(x => {
          this.config.configDefaultPropColumn.push({prop: x.prop})
          this.config.configDefaultPropColumnMap.set(x.prop,x)
        })
      })

    },
    assignPropertiesLarge (arr1, arr2, compareProp, assignProps) {
      const map = new Map();
      arr2.forEach(item => {
        map.set(item[compareProp], item);
      });
      arr1.forEach(item => {
        const match = map.get(item[compareProp]);
        if (match) {
          assignProps.forEach(prop => {
            item[prop] = match[prop];
          });
          item.check = true
        } else {
          item.check = false
        }
      });
      return arr1;
    },
    reorderArray(arr1, arr2, key) {
      if (arr2.length === 0) {
        return arr1;
      }

      // 存储第二个数组中元素的特定属性值
      const targetValues = arr2.map(item => item[key]);
      // 存储匹配的元素
      const matched = [];
      // 存储未匹配的元素
      const unmatched = [];

      // 遍历第一个数组，将匹配的元素和未匹配的元素分别存储
      for (const item of arr1) {
        if (targetValues.includes(item[key])) {
          matched.push(item);
        } else {
          unmatched.push(item);
        }
      }

      // 对匹配的元素进行排序，使其顺序与第二个数组一致
      const sortedMatched = targetValues.map(value => {
        return matched.find(item => item[key] == value);
      }).filter(item => item!== undefined);
      // 合并匹配的元素和未匹配的元素
      return [...sortedMatched, ...unmatched];
    },
    templateConfigurationMode(type) {
      // 开启配置模式
      if (type === 0) {
        this.config.isConfigMode = true
        this.$nextTick(() => {
          const tree = this.$refs.configTableListTree;
          this.config.configDefaultColumn.forEach((node) => {
            if (node.check) {
              tree.setChecked(node.prop, true);
            }
          });
        })
      }
      // 保存/修改配置模式
      else if (type === 1 || type === 2) {
        // 检测
        if (!this.config.configModeForm.name) {
          this.$message.error('请输入配置模板名称!');
          return
        }
        if (type === 2) {

          if (!this.config.configId) {
            this.$message.error('未检测出有配置相关模板并启用,请新增!');
            return
          }
        }
        this.$nextTick(() => {
          let submitTable = myJsonClon.getClone(this.config.configModeForm)
          submitTable.tableId = this.config.configTableId
          submitTable.id = type === 2 ? this.config.configId : undefined
          const tableRef = this.$refs.tableRef;
          let tmsTabulationConfigValueList = []
          tableRef.columns.forEach((x,index) => {
            tmsTabulationConfigValueList.push({label: x.label,prop: x.property,fixed: x.fixed,width: x.width,sort: index})
          })
          submitTable.tmsTabulationConfigValueList = tmsTabulationConfigValueList;
          this.$http({
            url: this.$http.adornUrl(type === 1 ? '/tabulation/add' : '/tabulation/update'),
            method: type === 1 ? 'post' : 'put',
            data: submitTable
          }).then(async ({ data }) => {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1000,
            })
            window.location.reload()
          })

        })
      }
    },
    getFormatter(formatterName) {
      if (formatterName) {
        // 首先尝试从组件的 methods 中获取方法
        let method = this[formatterName];
        if (typeof method === 'function') {
          return method;
        }
        // 若组件的 methods 中没有，再尝试从 Vue.prototype 中获取方法
        method = Vue.prototype[formatterName];
        if (typeof method === 'function') {
          return method;
        }
      }
      // 若都没找到，返回一个直接返回原始值的函数
      return (row, column, cellValue) => cellValue;
    },
    checkAllNodes (isChecked) {
      this.$nextTick(() => {
        if (isChecked) {
          this.$refs.configTableListTree.setCheckedNodes(this.config.configDefaultPropColumn)
        } else {
          this.$refs.configTableListTree.setCheckedKeys([])
          this.$forceUpdate()
        }
      })
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
      const tree = this.$refs.configTableListTree;
      tree.setChecked(draggingNode.data.prop, draggingNode.data.check);
    },
    handleCheckChange(data, checked, indeterminate) {
      const targetElement = this.config.configDefaultColumn.find(item => item.prop === data.prop);
      targetElement.check = checked
    },
    allowDrag(draggingNode) {
      return draggingNode.data.fixed ? false : true
    },
    allowDrop(draggingNode, dropNode, type) {
      return type === 'inner' ? false : true
    },
    getCellClassName({ row, column, rowIndex, columnIndex }) {
      let newVar = this.config.configDefaultPropColumnMap.get(column.property);
      if (newVar && newVar.styleClass) {
        return newVar.styleClass;
      }
      return '';
    },
    // -----------------动态表格模式end-----------------

    viewBill (row) {
      this.$refs.viewBill.init(row, '周')
    },
    /**
     * 点击表格变色start
     */
    selectedHighlight ({ row, rowIndex }) {
      if ((this.getIndex) === rowIndex) {
        return {
          'background-color': 'rgb(250, 195, 100)'
        }
      }
    },
    rowClick (row) {
      this.getIndex = row.index
    },
    /**
     * 点击表格变色end
     */
    handleSelectionChange (row) {
      this.selectFeeData = row
    },
    // 发送邮件
    sendEmail (type, rows) {
      let ids = ''
      if (type === 'single') {
        ids = rows.id
      } else {
        ids = []
        this.selectFeeData.forEach((item, index) => {
          ids.push(item.id)
        })
      }
      this.$http({
        url: this.$http.adornUrl('/costInfo/sendOrderBill/' + ids),
        method: 'POST'
      }).then(({ data }) => {
        this.$message.success('发送成功，请注意查收')
        this.getDataList()
      })
    },
    // 删除
    deleteHandle (row) {
      let title = ''
      if(!!row) {
        title = `【${row.name}】`
      } else {
        title = ''
      }
      this.$confirm('确定删除账单' + title + '?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let ids = []
        if(!!row) {
          ids.push(row.id)
        } else {
          this.selectFeeData.forEach((item, index) => {
            ids.push(item.id)
          })
        }
        this.$http({
          url: this.$http.adornUrl(`/costInfo/deleteCostBill`),
          method: 'delete',
          data: this.$http.adornParams({
            ids: ids
          })
        }).then(({data}) => {
          if (data) {
            this.$message({
              message: '删除成功',
              type: 'success',
              duration: 1000,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error('删除失败')
          }
        })
      }).catch(() => {})
    },
    // 获取数据列表
    getDataList () {
      this.dataListLoading = true
      if (!this.newAuth('bill:week:findAll')) {
        this.dataForm.customerId = this.currentUser.customerId
        this.dataForm.customerIdList = this.currentUser.customerIdList
      }
      let param = {
        'page': this.pageIndex,
        'limit': this.pageSize,
        'name': this.dataForm.name,
        'customerName': this.dataForm.customerName,
        'customerId': this.dataForm.customerId,
        'type': this.dataForm.type,
        'billType': this.dataForm.billType,
        'customerIdList': this.dataForm.customerIdList
      }
      const params = qs.stringify(param, { arrayFormat: 'repeat' })
      this.$http({
        url: this.$http.adornUrl('/costInfo/getOrderBillList?' + params),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({ data }) => {
        if (data) {
          this.dataList = data.list
          this.totalPage = data.total
        } else {
          this.dataList = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },

    // 导出2.0
    downLoadV2(id) {
      this.tabulation = this.$options.data().tabulation;
      this.tabulation.type = 0;
      let configTableViewBill = this.$refs.viewBill.getConfigTable();
      this.commonSubmitReceivableCustomer(id, configTableViewBill);
    },
    downLoadExcel(requestV) {
      const loading = this.$loading({
        lock: true,
        text: '正在导出,请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$http({
        url: this.$http.adornUrl('/export/receivableCustomer/' + requestV.ids),
        method: 'post',
        responseType: 'blob',
        data: this.$http.adornData(requestV)
      }).then(async ({ data }) => {
        const blob = data
        const reader = new FileReader()
        reader.readAsDataURL(blob)
        reader.onload = (e) => {
          const a = document.createElement('a')
          a.download = (this.tenantInfo ? this.tenantInfo.forShort : '快提货') + '-每周账单核对表.xls'
          a.href = e.target.result
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        }
      }).catch(() => {
        this.$message.error('导出模板发生异常!')
      }).finally(() => {
        loading.close();
        this.tabulation.show = false
      })
    },
    // 发送邮件2.0
    sendEmailV2 (type, rows) {
      this.tabulation = this.$options.data().tabulation
      this.tabulation.type = 1;
      let configTableViewBill = this.$refs.viewBill.getConfigTable();
      let ids = []
      if (type === 'single') {
        ids.push(rows.id)
      } else {
        this.selectFeeData.forEach((item, index) => {
          ids.push(item.id)
        })
      }
      this.commonSubmitReceivableCustomer(ids,configTableViewBill);
    },
    sendEmailExcel(requestV) {
      const loading = this.$loading({
        lock: true,
        text: '正在发送,请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$http({
        url: this.$http.adornUrl('/export/sendReceivableCustomer'),
        method: 'post',
        data: this.$http.adornData(requestV)
      }).then(async ({ data }) => {
        this.$message.success('发送成功，请注意查收')
        this.getDataList()
      }).catch(() => {
        this.$message.error('发送模板异常!')
      }).finally(() => {
        loading.close();
        this.tabulation.show = false
      })
    },
    // 导出/发邮件-中转
    commonSubmitReceivableCustomer(id,configTableViewBill) {
      let that = this
      let ids = that.tabulation.type == 0 ? [id] : id;
      that.tabulation.ids = ids
      that.$http({
        url: that.$http.adornUrl('/tabulation/list/' + configTableViewBill.configTableId),
        method: 'get',
        params: that.$http.adornParams()
      }).then(async ({ data }) => {
        if (data && data.length > 1) {
          that.tabulation.show = true
          that.tabulation.tabulationList = data
        } else {
          let tmsTabulationConfigValueVO = configTableViewBill.configDefaultColumn.filter(x => x.check).map(x => {
            return {label: x.label, prop: x.prop,parentLabel: x.parentLabel}
          })
          let requestV = {
            ids: ids,
            mainTitle: (this.tenantInfo ? this.tenantInfo.forShort : '快提货') + '-每周账单核对表',
            tmsTabulationConfigValueVO: tmsTabulationConfigValueVO
          }
          if (this.tabulation.type == 0) {
            this.downLoadExcel(requestV)
          } else {
            this.sendEmailExcel(requestV)
          }
        }
      }).catch((err) => {
        this.$message.error('处理模板发生异常!')
      })
    },
    submitCommonSubmitReceivableCustomer() {
      if (!this.tabulation.configId) {
        this.$message.error('请选择模板!')
        return;
      }
      let configTableViewBill = this.$refs.viewBill.getConfigTable();
      let tabulationInfo = this.tabulation.tabulationList.filter(x => x.id == this.tabulation.configId)[0];
      let cloneTabulationInfo = myJsonClon.getClone(tabulationInfo);
      if (cloneTabulationInfo.tmsTabulationConfigValueList && cloneTabulationInfo.tmsTabulationConfigValueList.length > 0) {
        this.assignPropertiesLarge(configTableViewBill.configDefaultColumn, cloneTabulationInfo.tmsTabulationConfigValueList,'prop',['label','fixed','width'])
        configTableViewBill.configDefaultColumn = this.reorderArray(configTableViewBill.configDefaultColumn, cloneTabulationInfo.tmsTabulationConfigValueList, 'prop');
      }
      let tmsTabulationConfigValueVO = configTableViewBill.configDefaultColumn.filter(x => x.check).map(x => {
        return {label: x.label, prop: x.prop,parentLabel: x.parentLabel}
      })
      let requestV = {
        ids: this.tabulation.ids,
        mainTitle: (this.tenantInfo ? this.tenantInfo.forShort : '快提货') + '-每周账单核对表',
        tmsTabulationConfigValueVO: tmsTabulationConfigValueVO
      }
      if (this.tabulation.type == 0) {
        this.downLoadExcel(requestV)
      } else {
        this.sendEmailExcel(requestV)
      }
    },
  }
}
</script>
<style lang="less" scoped>
div#pane-costManagement-supplierFee {
}
:deep(.my-table-cell) {
  background-color: antiquewhite!important;
}
:deep(.my-table-cell-v2) {
  background-color: beige!important;
}
:deep(.my-table-cell-v3) {
  background-color: aliceblue!important;
}
</style>
